import React, { useEffect, useState } from 'react';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { StateMethods, useHookstate } from '@hookstate/core';
import { getAllTypes } from '~/features/Type/services';
import { getTypeDocuments } from './services';
import { TypeDocumentResponse } from './interfaces';

interface FilterAutoCompleteTypeDocumentsProps {
    readonly onTypeDocumentsChange: (value: number | null) => void;
    readonly typeDocumentsId?: number | null;
    readonly disabled?: boolean
}

export default function FilterAutocompleteTypeDocuments({ disabled, typeDocumentsId, onTypeDocumentsChange }: FilterAutoCompleteTypeDocumentsProps) {
    const { translate } = useLang();
    const [options, setOptions] = useState<readonly TypeDocumentResponse[]>([]);
    const [value, setValue] = useState<TypeDocumentResponse | null>(null);
    const loading = useHookstate(false);

    useEffect(() => {
        getTypeDocuments().then(response => {
            setOptions(response)
            setValue(null)
        })
    }, [])

    useEffect(() => {
        if (!typeDocumentsId) {
            setValue(null)
        } else {
            setValue(options.find(opt => opt.id === typeDocumentsId) ?? null)
        }
    }, [typeDocumentsId])

    return (
        <FormControl fullWidth size='small'>
            <Autocomplete
                id='filter-types-documents'
                disabled={disabled}
                options={options}
                value={value}
                noOptionsText={translate('No options')}
                size='small'
                loading={loading.get()}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name ?? ''}
                onChange={(_, type) => {
                    setValue(type);
                    onTypeDocumentsChange(type?.id ?? null);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate('Document Type')}
                    />
                )}
            />
        </FormControl>
    )
}